<template>
  <span>
    <b-button
      class="float-right"
      v-if="selected.length > 1"
      v-b-modal.modal-bulk-pallet
    >
      Pesaje múltiple
    </b-button>

    <b-modal
      id="modal-bulk-pallet"
      @ok="handleOk"
      @cancel="clear"
      title="Pesaje múltiple"
      size="lg"
    >
      <b-row>
        <b-col lg="6">
          <b-jumbotron>
            <template slot="header">
              <p>{{ calculateGross }}</p>
            </template>

            <template slot="lead">
              <p class="font-weight-bold font-4xl" style="text-align:center;">
                {{ socketWeight }}<br />
                Kg Brutos
              </p>
            </template>
            <p v-if="!connected" class="text-danger">
              * Conexión con báscula no establecida
            </p>
          </b-jumbotron>
        </b-col>

        <b-col lg="6">
          <b-form-group>
            <label class="font-weight-bold" for="name">Peso Bruto</label>
            <b-form-input
              v-model="$v.current_weight.$model"
              :state="
                $v.current_weight.$dirty ? !$v.current_weight.$error : null
              "
              type="text"
              autocomplete="off"
            >
            </b-form-input>
          </b-form-group>
          <b-button
            pill
            block
            :disabled="weights.length >= itemsSelectedCount"
            @click.prevent="captureWeight($v.current_weight.$model)"
            class="mb-2"
          >
            Capturar: {{ current_weight }} Kg
          </b-button>
          <p>Pesajes: {{ weightSplit }}</p>
          <ul v-for="(item, key) in selected">
            <li>{{ item.number }} / {{ computedWeights[key] }} Kg</li>
          </ul>
        </b-col>
      </b-row>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { required, decimal, maxValue } from "vuelidate/lib/validators";
import { bus } from "../../../main";

const mustBeLowerThanLastWeight = (value, vm) => {
  let result = true;
  if (Array.isArray(vm.weights) && vm.weights.length) {
    result = parseFloat(vm.weights[vm.weights.length - 1]) > value;
  }
  return result;
};

export default {
  name: "BulkPalletSet",
  data() {
    return {
      current_weight: 0,
      weights: [] //el primero debe pesar 490, el segundo 500 y el tercero 510
    };
  },
  watch: {
    socketWeight(newValue, oldValue) {
      this.current_weight = newValue;
    }
  },
  computed: {
    ...mapState("bagnoArrivalModule", ["selected"]),
    ...mapState("socketModule", ["socketWeight", "connected"]),
    ...mapGetters("bagnoArrivalModule", ["itemsSelectedCount"]),
    // netWeight() {
    //   return this.form.gross_weight - this.form.pallet_weight -
    //     (this.form.quantity * this.selected.material_weight)
    // }
    computedWeights() {
      let array = [];
      if (this.weights.length) {
        let num = 0;
        let idx = 0;
        let last_weight = this.weights[this.weights.length - 1];
        do {
          num = this.weights[idx] - this.weights[idx + 1];
          if (!Number.isNaN(num)) {
            array.push(parseFloat(num).toFixed(2));
          }
          idx += 1;
        } while (idx <= this.weights.length - 2);
        array.push(last_weight);
      }
      return array;
    },
    weightSplit() {
      return this.weights.join(", ");
    }
  },
  methods: {
    clear() {
      this.weights = [];
      this.current_weight = 0;
    },
    updateRow(item, gross_kilograms) {
      const data = {
        id: item.idx,
        quantity: 1,
        gross_weight: parseFloat(gross_kilograms).toFixed(2),
        container: item.container,
        netWeight: gross_kilograms - item.material_weight
      };
      this.$store.dispatch("bagnoArrivalModule/updateRow", data);
    },
    handleOk() {
      this.selected.forEach((item, idx) => {
        this.updateRow(item, this.computedWeights[idx]);
      });
      // Emit an event to clear selected rows
      bus.$emit("clearSelectedRows", this.selected);
      this.clear();
    },
    captureWeight(value) {
      this.weights.push(value);
      this.current_weight = 0;
    }
  },
  validations: {
    current_weight: {
      required,
      decimal,
      mustBeLowerThanLastWeight
    }
  }
};
</script>

<style scoped></style>
